// ABOUTME: Reusable two-column Grid layout component for hierarchy-based interfaces

import { Grid } from '@ds/coolshop';
import { ReactNode } from 'react';

type ITwoColumnLayoutProps = {
    leftColumn: ReactNode;
    rightColumn: ReactNode;
};

export function TwoColumnLayout(props: ITwoColumnLayoutProps) {
    const { leftColumn, rightColumn } = props;

    return (
        <Grid container height="100%" spacing={2}>
            <Grid item xs={12} sm={4} md={2.5} height="100%">
                {leftColumn}
            </Grid>

            <Grid item xs={12} sm={8} md={9.5} height="100%">
                {rightColumn}
            </Grid>
        </Grid>
    );
}
